import React, { Component } from 'react';

import ModalEditClip from '../components/ModalEditClip/ModalEditClip';
import ResizeObserver from '../components/ResizeObserver/ResizeObserver';

class App extends Component {
  render() {
    return (
      <div>
        <ResizeObserver>
          <ModalEditClip />
        </ResizeObserver>
      </div>
    );
  }
}

export default App;
